import { render, staticRenderFns } from "./LeaseItemsTabScreen.vue?vue&type=template&id=ca73e662&"
import script from "./LeaseItemsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseItemsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports